import React, { Component } from 'react';
import ReactGA from 'react-ga';
import 'bootstrap/dist/css/bootstrap.min.css';
import data from './data.js';
import {
  Container,
  Row,
  Col
} from 'react-bootstrap';

import SideNavComponent from './Component/SideNavComponent';
import ChatComponent from './Component/ChatComponent';
ReactGA.initialize('UA-154144210-1');
ReactGA.pageview(window.location.pathname + window.location.search);

class App extends Component {
  constructor() {
    super();
    this.state = {
      active: false,
    }
  }
  activateChat = (val) => {
    this.setState({ active: val });
    
  }
  render() {
    return (
      <Container fluid={true}>
        <Row className="vh-100">
          <Col sm={4} className="border-right scrollable px-0" >
            <SideNavComponent data={data}></SideNavComponent>
          </Col>
          <Col sm={8} className="scrollable px-0">
            <ChatComponent data={data} activateChat={this.activateChat}></ChatComponent>

          </Col>
        </Row>
      </Container>
    )
  }
}

export default App;
